// Shared client-side pagination for long lists (page over an already-loaded
// array - no re-fetch per page). Extracted from inventoryView.js's Items/POs/
// History pager (2026-08-27) so loyaltyView.js's customer list can reuse the
// same look and behavior instead of re-implementing it.

export const pageSlice = function (arr, page, pageSize) {
  const totalPages = Math.max(1, Math.ceil(arr.length / pageSize));
  const clamped = Math.min(Math.max(1, page), totalPages);
  const start = (clamped - 1) * pageSize;
  return { pageItems: arr.slice(start, start + pageSize), page: clamped, totalPages, total: arr.length, start };
};

// Page numbers with ellipsis truncation for large page counts.
const pageButtons = function (page, totalPages) {
  if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
  const set = new Set([1, 2, totalPages - 1, totalPages, page - 1, page, page + 1]);
  const arr = [...set].filter((p) => p >= 1 && p <= totalPages).sort((a, b) => a - b);
  const out = [];
  arr.forEach((p, i) => { if (i > 0 && p - arr[i - 1] > 1) out.push('…'); out.push(p); });
  return out;
};

export const pagerHtml = function (id, { page, totalPages, total, start, count, pageSize, pageSizeOptions, label }) {
  if (!total) return '';
  const from = start + 1;
  const to = start + count;
  const pageBtns = pageButtons(page, totalPages).map((p) =>
    p === '…'
      ? `<span class="pg-dots">…</span>`
      : `<button class="pg-btn${p === page ? ' pg-btn--active' : ''}" data-page="${p}" type="button">${p}</button>`
  ).join('');
  return `
    <div class="inv-pager" id="${id}">
      <div class="inv-pager-info">
        Showing <strong>${from.toLocaleString('en-US')}–${to.toLocaleString('en-US')}</strong> of <strong>${total.toLocaleString('en-US')}</strong> ${label}
        <select class="inv-cat-select inv-pager-size" data-role="pagesize">
          ${pageSizeOptions.map((n) => `<option value="${n}"${n === pageSize ? ' selected' : ''}>${n} / page</option>`).join('')}
        </select>
      </div>
      <div class="inv-pager-nav">
        <button class="pg-btn" data-page="${page - 1}" type="button" ${page <= 1 ? 'disabled' : ''}>‹</button>
        ${pageBtns}
        <button class="pg-btn" data-page="${page + 1}" type="button" ${page >= totalPages ? 'disabled' : ''}>›</button>
      </div>
    </div>`;
};

export const wirePager = function (id, onPage, onPageSize) {
  const el = document.getElementById(id);
  if (!el) return;
  el.addEventListener('click', (e) => {
    const btn = e.target.closest('.pg-btn');
    if (!btn || btn.disabled) return;
    onPage(parseInt(btn.dataset.page, 10));
  });
  el.querySelector('[data-role="pagesize"]')?.addEventListener('change', (e) => onPageSize(parseInt(e.target.value, 10)));
};
